import { createContext } from 'react';

const AuthContext = createContext({
  isLoading: true,
  isLogin: false,
  user: null,
  isCompanyLogin: false,
  permission: null,
  employee: null,
  redirect: null,
  setAuthState: () => { }
});

export default AuthContext;
